// src/components/Home.js
import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FundSelector from '../features/funds/FundSelector';

function UserFundPlanner() {
  return (
    <Container>
      <FundSelector />
    </Container>
  );
}

export default UserFundPlanner;

